import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/summer-vacation-2025-homework/Index.vue')
const StudentsRecords = () => import('../activity/summer-vacation-2025-homework/StudentsRecords.vue')
const TeachersRecords = () => import('../activity/summer-vacation-2025-homework/TeachersRecords.vue')

// RSummerVacation2025Homework
export const RSummerVacation2025Homework: RouteConfig = {
  path: '/summer-vacation-2025-homework',
  name: 'summer_vacation_2025_homework',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2025暑假体育作业落实方案',
    ignoreLogin: true,
    keepAlive: true,
  },
}

const RSummerVacation2025HomeworkStudentsRecords: RouteConfig = {
  path: '/summer-vacation-2025-homework/students-records',
  name: 'summer_vacation_2025_homework_students_records',
  component: StudentsRecords,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '查收记录',
  },
}

const RSummerVacation2025HomeworkTeachersRecords: RouteConfig = {
  path: '/summer-vacation-2025-homework/teachers-records',
  name: 'summer_vacation_2025_homework_teachers_records',
  component: TeachersRecords,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '邀请记录',
  },
}

export default [
  RSummerVacation2025Homework,
  RSummerVacation2025HomeworkStudentsRecords,
  RSummerVacation2025HomeworkTeachersRecords,
]
